import { ca } from '@cian/analytics';

export function trackReliableLabelHover(newbuildingId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'JK_problems_icon_hover',
    label: `green/${newbuildingId}`,
    useLastProducts: true,
  });
}

export function trackReliableMoreTooltipClick(newbuildingId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'JK_problems_more_click_tooltip',
    label: `green/${newbuildingId}`,
    useLastProducts: true,
  });
}

export function trackReliableLabelClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'tab_reliable_dev',
    useLastProducts: true,
  });
}

export function trackEscrowLabelClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'tab_escrow',
    useLastProducts: true,
  });
}
